export default {"src":"/_next/static/media/instagram-bold.b21d2fab.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};